import { jsx as _jsx } from "react/jsx-runtime";
import { assertUnreachableValue } from '#pplx/frontend/common/type_utils/unreachableValue.js';
import { CommandMenuPanel } from '#pplx/frontend/composer-sdk/components/internal/CommandMenuPanel/index.js';
import { INLINE_PANEL_HEIGHT_PX as INTERNAL_INLINE_PANEL_HEIGHT_PX, INLINE_PANEL_WIDTH_PX as INTERNAL_INLINE_PANEL_WIDTH_PX, InlinePanel, } from '#pplx/frontend/composer-sdk/components/internal/InlinePanel/index.js';
import { SpotlightPanel } from '#pplx/frontend/composer-sdk/components/internal/SpotlightPanel/index.js';
import { SuggestDropdownPanel } from '#pplx/frontend/composer-sdk/components/internal/SuggestDropdownPanel/index.js';
import React from 'react';
export const INLINE_PANEL_HEIGHT_PX = INTERNAL_INLINE_PANEL_HEIGHT_PX;
export const INLINE_PANEL_WIDTH_PX = INTERNAL_INLINE_PANEL_WIDTH_PX;
/**
 * Shared visual shell for the three menu/dropdown surfaces rendered around the
 * Ask composer: the Computer command menu (`commandMenu`), the autosuggest
 * popover (`suggestDropdown`), and the inline @-mention popover (`inline`).
 *
 * The panel owns the shared chrome, spacing, borders, and (for `inline`) the
 * caret-anchored positioning strategy. Call sites own only the content they
 * render inside it, except for the existing `suggestDropdown` composer state
 * classes used for decorative glow (the dashed stroke look is expressed via
 * the semantic `isDashedStroke` prop).
 *
 * @example Inline popover
 * ```tsx
 * <CommandPanel
 *   variant="inline"
 *   isTop={isTop}
 *   viewportCollisionLeftOffsetPx={viewportCollisionLeftOffsetPx}
 *   fitContent={fitContent}
 * >
 *   <div role="menu" className="flex w-full flex-col gap-px">
 *     {optionNodes}
 *   </div>
 * </CommandPanel>
 * ```
 *
 * @example Command menu with a detail side panel
 * ```tsx
 * <CommandPanel
 *   variant="commandMenu"
 *   onBodyScroll={handleMenuScroll}
 *   sidePanel={selectedItem ? <CommandDetail item={selectedItem} /> : undefined}
 * >
 *   {menuItems}
 * </CommandPanel>
 * ```
 */
export const CommandPanel = React.memo(function CommandPanel(props) {
    switch (props.variant) {
        case 'commandMenu':
            return _jsx(CommandMenuPanel, { ...props });
        case 'suggestDropdown':
            return _jsx(SuggestDropdownPanel, { ...props });
        case 'spotlight':
            return _jsx(SpotlightPanel, { ...props });
        case 'inline':
            return _jsx(InlinePanel, { ...props });
        default:
            return assertUnreachableValue(props);
    }
});
//# sourceMappingURL=CommandPanel.js.map